import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "sc-trend-prefix"
};
const _hoisted_2 = {
    class: "sc-trend-value"
};
const _hoisted_3 = {
    class: "sc-trend-suffix"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_icon_top = _resolveComponent("el-icon-top");
    const _component_el_icon = _resolveComponent("el-icon");
    const _component_el_icon_bottom = _resolveComponent("el-icon-bottom");
    const _component_el_icon_right = _resolveComponent("el-icon-right");
    return _openBlock(), _createElementBlock("span", {
        class: _normalizeClass([
            "sc-trend",
            'sc-trend--' + $options.type
        ])
    }, [
        $options.iconType == 'P' ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            class: "sc-trend-icon"
        }, {
            default: _withCtx(()=>[
                    _createVNode(_component_el_icon_top)
                ]),
            _: 1
        })) : _createCommentVNode("", true),
        $options.iconType == 'N' ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 1,
            class: "sc-trend-icon"
        }, {
            default: _withCtx(()=>[
                    _createVNode(_component_el_icon_bottom)
                ]),
            _: 1
        })) : _createCommentVNode("", true),
        $options.iconType == 'Z' ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 2,
            class: "sc-trend-icon"
        }, {
            default: _withCtx(()=>[
                    _createVNode(_component_el_icon_right)
                ]),
            _: 1
        })) : _createCommentVNode("", true),
        _createElementVNode("em", _hoisted_1, _toDisplayString($props.prefix), 1),
        _createElementVNode("em", _hoisted_2, _toDisplayString($props.modelValue), 1),
        _createElementVNode("em", _hoisted_3, _toDisplayString($props.suffix), 1)
    ], 2);
}
